import { withTranslation /* , i18n */ } from 'server/i18n'
import { NextSeo } from 'next-seo'
import PropTypes from 'prop-types'
import { Box, Flex } from 'reflexbox'
import getConfig from 'next/config'

import ContactInfo from 'components/ContactInfo'
import TextBlock from 'components/TextBlock'
import BlockTitle from 'components/BlockTitle'

import layoutTheme from 'theme/layout-theme'
import PageTitle from 'components/PageTitle'
import Map from 'components/Map'

const { publicRuntimeConfig } = getConfig()
const { CLOUDINARY_URL, DOMAIN_ROOT } = publicRuntimeConfig

const PrivacyPolicy = ({ canonical, t, i18n }) => {
    // @TODO: Change SEO for contact page
    const seoData = {
        title: `${t('meta-data:contact-title')} | Merk & Merk`,
        description: t('meta-data:contact-description'),
        canonical: t('meta-data:contact-url'),
        openGraph: {
            title: `${t('meta-data:contact-title')} | Merk & Merk`,
            description: t('meta-data:contact-description'),
            url: t('meta-data:contact-url'),
            images: [
                {
                    url: `${CLOUDINARY_URL}/v1582632369/Static/sell-image_hace64.jpg`
                }
            ]
        },
        languageAlternates: [
            {
                hrefLang: 'en',
                href: `${DOMAIN_ROOT}/contact`
            },
            {
                hrefLang: 'de',
                href: `${DOMAIN_ROOT}/de/contact`
            }
        ]
    }

    return (
        <main>
            <NextSeo {...seoData} />
            <Box theme={layoutTheme} px={20} mt={[80, null, null, 140]} mb={80} maxWidth={1360} mx="auto">
                <PageTitle title={t('contact')} subtitle={t('get-in-touch-with-us')} titleTag="h1" />
            </Box>

            <Box theme={layoutTheme} variant="center1360" px={20}>
                <ContactInfo />
            </Box>

            <Flex theme={layoutTheme} variant="mapTitle">
                <Box theme={layoutTheme}>
                    <BlockTitle title={t('our-location')} subtitle={t('contact-text')} />
                </Box>

                <Box theme={layoutTheme} variant="mapAddress">
                    {/* eslint-disable-next-line max-len */}
                    <TextBlock text="<address>Jurjevgradska 2, Marina Tribunj<br> HR-22212 Tribunj, Croatia</address>" />
                </Box>
            </Flex>

            <Box theme={layoutTheme} mb={[20, null, 80, 190]} variant="center1600">
                <Map />
            </Box>

            <Box theme={layoutTheme} mb={100} px="20px" mx="auto" display={['block', null, 'none']}>
                <TextBlock text="<address>Jurjevgradska 2, Marina Tribunj<br> HR-22212 Tribunj, Croatia</address>" />
            </Box>
        </main>
    )
}

PrivacyPolicy.getInitialProps = async ({ req: { i18n } = {} }) => {
    return {
        canonical: i18n ? i18n.getFixedT('en')('meta-data:newsletter-url') : undefined,
        namespacesRequired: ['common', 'meta-data']
    }
}

PrivacyPolicy.propTypes = {
    canonical: PropTypes.string,
    i18n: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    t: PropTypes.func.isRequired
}

PrivacyPolicy.defaultProps = {
    canonical: undefined
}

export default withTranslation('common', 'meta-data')(PrivacyPolicy)
